import { FC, createElement, useCallback, useEffect, useMemo } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { useWebgate } from '@xvia/webgate-connect';
import { IJourneyService } from '../../apis/journeys';
import { useJourneyTree } from '../../hooks/use-journey-tree';
import { ROUTES } from '../../routes';
import { Journey, JourneyProps } from './journey';

export const JourneyContainer: FC = () => {
  const { portalConnect } = useWebgate();
  const history = useHistory();
  const { journey: slug } = useParams<{ journey: string }>();
  const journeyTree = useJourneyTree();

  const journey = useMemo(
    () => journeyTree.find((item) => item.slug === slug),
    [journeyTree, slug]
  );

  useEffect(() => {
    if (typeof window !== 'undefined' && window.scrollY !== 0) {
      window.scrollTo(0, 0);
    }
  }, [slug]);

  const onClickService = useCallback(
    (service: IJourneyService) => {
      const link = service.publicUrl;

      if (!link) {
        history.push(`${ROUTES.SERVICE_LIST_PAGE}/${service.slug}`);
        return;
      }

      if (link.indexOf('/app/') !== -1) {
        portalConnect?.redirectTo(link);
        return;
      }

      window.open(link, '_blank');
    },
    [history, portalConnect]
  );

  const journeyProps: JourneyProps = {
    journey,
    onClickService,
    breadcrumbs: [
      { name: 'Jornada do Cidadão', path: ROUTES.JOURNEY_LIST_PAGE },
      { name: journey?.title || 'Jornada' },
    ],
  };

  return createElement(Journey, journeyProps);
};
